import React, { ReactNode, useState, useRef, useEffect } from 'react'
import useOnClickOutside from './useOnClickOutside'
import { SelectContext } from './SelectContext'
import './select.scss'
import { observer } from 'mobx-react'

import { ReactComponent as ArrowDown } from '../../../assets/arr-down.svg'
import classNames from 'classnames'

const Select: React.FC<{
  children: ReactNode | ReactNode[]
  defaultValue?: string
  placeholder?: string
  onSelect?: (selectedOption: string) => void
}> = observer(({ children, defaultValue, placeholder, onSelect }) => {
  const [selectedOption, setSelectedOption] = useState(defaultValue || '')
  const [showDropdown, setShowDropdown] = useState(false)
  const showDropdownHandler = () => setShowDropdown(!showDropdown)
  const selectPlaceholder = defaultValue || 'Choose an option'
  const selectContainerRef = useRef(null)

  const clickOutsideHandler = () => setShowDropdown(false)

  useOnClickOutside(selectContainerRef, clickOutsideHandler)

  const updateSelectedOption = (option: string) => {
    setSelectedOption(option)
    onSelect && onSelect(option)
    setShowDropdown(false)
  }

  useEffect(() => {
    setSelectedOption(defaultValue || '')
  }, [defaultValue, selectedOption])

  return (
    <SelectContext.Provider
      value={{ selectedOption, changeSelectedOption: updateSelectedOption }}
    >
      <div className="select-container" ref={selectContainerRef}>
        <div
          className={showDropdown ? 'selected-text active' : 'selected-text'}
          onClick={showDropdownHandler}
        >
          <span>
            {selectedOption.length > 0 ? selectedOption : selectPlaceholder}
          </span>
          <div className={classNames('select-icon', showDropdown && 'show-drop')}>
            <ArrowDown />
          </div>
        </div>
        <ul
          className={
            showDropdown
              ? 'select-options show-dropdown-options'
              : 'select-options hide-dropdown-options'
          }
        >
          {children !== defaultValue && children}
        </ul>
      </div>
    </SelectContext.Provider>
  )
})

export default Select
